// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This style file is imported by Home.js which renders the service inventory page.
*/

body {
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  margin: 0;
  padding: 0;
  background-color: whitesmoke;
  width: 100% !important;
  max-width: 100%;
  overflow-x: hidden;
}

.navbar-content{
  margin-top:0%;
}

.content-container {
  position: relative;
  padding: 1% 1%;
  margin-top: 4%;
  margin-left: 3%;
}

.time-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 1% 1%;
  gap: 1%;
  height: 1.8rem;
  margin-bottom: 5px;
  margin-right: 2%;
  margin-top: 1%;
}

.refresh-button {
  background-color: #0C3135;
  color: white;
  font-size: 15px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  padding: 0.5rem;
  height: 2.0rem;
  width: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.refresh-button:hover {
  background-color: #2a5a5a;
}

.refresh-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Download button styles - add these in Home.css */
.download-button {
  background-color: #0C3135;
  color: white;
  font-size: 15px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  padding: 0.5rem 1rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.download-button:hover {
  background-color: #2a5a5a;
}

.download-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: #2a5a5a !important;
}

.dropbox-table {
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 2% 3%;
  padding-right: 5%;
  margin-top: 1%;
  margin-left: 3% !important;
  /* background: whitesmoke; */
  box-shadow: 0 4px 20px rgba(131, 129, 129, 0.08);
  border-radius: 16px;
  padding-left: 1%;
  margin-right: 2%;
}

.dropbox-container {
  margin-left: 1%;
}

.table-container {
  margin: 1% 0;
  padding-left: 10%;
  margin-left: 10%;
  width: 100%;
  padding-bottom: 1%;
  margin-top:0%;
}

/* Responsive adjustments */
@media  (max-width: 321px) {
  .time-container {
    margin-top: 15%;
    font-size: 5px;
    margin-left: 10%;
  }
  .time-container button{
    width:10vw;
  }
  .dropbox-table{
    padding: 1% 8%;
    margin-top: 1%;
  }
  .content-container {
    position: relative;
    padding: 1% 1%;
    margin-top: -8%;
    margin-left: -7%;
  }
}

@media (min-width: 321px) and (max-width: 376px)  {
  .time-container {
    margin-top: 13%;
    font-size: 5px;
    margin-left: 12%;
  }
  .time-container button{
    width:10vw;
  }
  .content-container {
    position: relative;
    padding: 1% 1%;
    margin-top: -10%;
    margin-left: -4%;
  }
  
}

@media  (min-width: 376px) and (max-width: 426px)  {
  .time-container {
    margin-top: 10%;
    font-size: 5px;
    margin-left: 8%;
  }
  .time-container button{
    width:10vw;
  }
}

@media (min-width: 426px) and (max-width: 769px) {
  .time-container {
    margin-top: 5%;
    font-size: 5px;
    margin-left: 50%;
  }
  .time-container button{
    width:5vw;
  }
}

@media (min-width: 769px) and (max-width: 1025px) {
  .time-container {
    margin-top: 2%;
    font-size: 5px;
    margin-left: 55%;
  }
  .time-container button{
    width:3vw;
  }
}

@media (min-width: 1025px) and (max-width: 1441px) {
  .time-container {
    margin-top: 0%;
    font-size: 5px;
    margin-left: 63%;
  }
  .time-container button{
    width:3vw;
  }
}

@media (min-width: 1441px) and (max-width: 1921px) {
  .time-container {
    margin-top: 0%;
    font-size: 5px;
    margin-left: 65%;
  }
  .time-container button{
    width:3vw;
  }
}

@media (min-width: 1921px){
  .time-container {
    margin-top: 0%;
    font-size: 15px;
    margin-left: 78%;
  }
  body{
    font-size: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ServiceInventoryDashboard/Home.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;EACE,kCAAkC;EAClC,eAAe;EACf,SAAS;EACT,UAAU;EACV,4BAA4B;EAC5B,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,OAAO;EACP,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,4BAA4B;EAC5B,gDAAgD;EAChD,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;IACd,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;EAClB;;AAEF;;AAEA;EACE;IACE,eAAe;IACf,cAAc;IACd,eAAe;EACjB;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,cAAc;IACd,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;IACd,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;IACd,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;IACd,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/*\nThis style file is imported by Home.js which renders the service inventory page.\n*/\n\nbody {\n  font-family: 'Poppins', sans-serif;\n  font-size: 16px;\n  margin: 0;\n  padding: 0;\n  background-color: whitesmoke;\n  width: 100% !important;\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\n.navbar-content{\n  margin-top:0%;\n}\n\n.content-container {\n  position: relative;\n  padding: 1% 1%;\n  margin-top: 4%;\n  margin-left: 3%;\n}\n\n.time-container {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 1% 1%;\n  gap: 1%;\n  height: 1.8rem;\n  margin-bottom: 5px;\n  margin-right: 2%;\n  margin-top: 1%;\n}\n\n.refresh-button {\n  background-color: #0C3135;\n  color: white;\n  font-size: 15px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  padding: 0.5rem;\n  height: 2.0rem;\n  width: 2.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n}\n\n.refresh-button:hover {\n  background-color: #2a5a5a;\n}\n\n.refresh-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Download button styles - add these in Home.css */\n.download-button {\n  background-color: #0C3135;\n  color: white;\n  font-size: 15px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  padding: 0.5rem 1rem;\n  height: 2.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n}\n\n.download-button:hover {\n  background-color: #2a5a5a;\n}\n\n.download-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background-color: #2a5a5a !important;\n}\n\n.dropbox-table {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  padding: 2% 3%;\n  padding-right: 5%;\n  margin-top: 1%;\n  margin-left: 3% !important;\n  /* background: whitesmoke; */\n  box-shadow: 0 4px 20px rgba(131, 129, 129, 0.08);\n  border-radius: 16px;\n  padding-left: 1%;\n  margin-right: 2%;\n}\n\n.dropbox-container {\n  margin-left: 1%;\n}\n\n.table-container {\n  margin: 1% 0;\n  padding-left: 10%;\n  margin-left: 10%;\n  width: 100%;\n  padding-bottom: 1%;\n  margin-top:0%;\n}\n\n/* Responsive adjustments */\n@media  (max-width: 321px) {\n  .time-container {\n    margin-top: 15%;\n    font-size: 5px;\n    margin-left: 10%;\n  }\n  .time-container button{\n    width:10vw;\n  }\n  .dropbox-table{\n    padding: 1% 8%;\n    margin-top: 1%;\n  }\n  .content-container {\n    position: relative;\n    padding: 1% 1%;\n    margin-top: -8%;\n    margin-left: -7%;\n  }\n}\n\n@media (min-width: 321px) and (max-width: 376px)  {\n  .time-container {\n    margin-top: 13%;\n    font-size: 5px;\n    margin-left: 12%;\n  }\n  .time-container button{\n    width:10vw;\n  }\n  .content-container {\n    position: relative;\n    padding: 1% 1%;\n    margin-top: -10%;\n    margin-left: -4%;\n  }\n  \n}\n\n@media  (min-width: 376px) and (max-width: 426px)  {\n  .time-container {\n    margin-top: 10%;\n    font-size: 5px;\n    margin-left: 8%;\n  }\n  .time-container button{\n    width:10vw;\n  }\n}\n\n@media (min-width: 426px) and (max-width: 769px) {\n  .time-container {\n    margin-top: 5%;\n    font-size: 5px;\n    margin-left: 50%;\n  }\n  .time-container button{\n    width:5vw;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1025px) {\n  .time-container {\n    margin-top: 2%;\n    font-size: 5px;\n    margin-left: 55%;\n  }\n  .time-container button{\n    width:3vw;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1441px) {\n  .time-container {\n    margin-top: 0%;\n    font-size: 5px;\n    margin-left: 63%;\n  }\n  .time-container button{\n    width:3vw;\n  }\n}\n\n@media (min-width: 1441px) and (max-width: 1921px) {\n  .time-container {\n    margin-top: 0%;\n    font-size: 5px;\n    margin-left: 65%;\n  }\n  .time-container button{\n    width:3vw;\n  }\n}\n\n@media (min-width: 1921px){\n  .time-container {\n    margin-top: 0%;\n    font-size: 15px;\n    margin-left: 78%;\n  }\n  body{\n    font-size: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
